import React, { Fragment, useState } from 'react';
import * as Yup from 'yup';
import { Formik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';

import {
    Switch,
    Typography,
    Divider,
    Dialog,
    DialogContent,
    DialogTitle,
    Box,
    Button,
    TextField,
    Grid,
    colors
} from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    avatar: {
        marginRight: theme.spacing(2),
        backgroundColor: colors.grey[200]
    }
}));

const Create = ({ item, open, closeCreation, createValues, dependencies }) => {

    const classes = useStyles();

    return (
        <Fragment>

            <Dialog aria-modal="true" open={open} aria-labelledby="form-dialog-title" maxWidth="md" className={classes.root} >
                <DialogTitle id="form-dialog-title">
                    <Typography
                        color="textPrimary"
                        variant="h4">
                        Contrato de Operação
                    </Typography>
                </DialogTitle>
                <Divider />
                <DialogContent>

                    <Formik
                        initialValues={item}
                        validationSchema={
                            Yup.object().shape((!item.creating) ? {
                                name: Yup.string().max(50).required('Cliente é obrigatório'),
                                detail: Yup.string().max(50).required('Nome é o obrigatório'),
                                description: Yup.string().max(150).required('Descrição é obrigatória')
                            }
                                :
                                {
                                    name: Yup.string().max(50).required('Cliente é obrigatóri0'),
                                    detail: Yup.string().max(50).required('Nome é o obrigatório'),
                                    description: Yup.string().max(150).required('Descrição é obrigatória'),
                                    firstname: Yup.string().max(25).required('Nome é obrigatório'),
                                    lastname: Yup.string().max(25).required('Sobrenome é o obrigatório'),
                                    username: Yup.string().max(50).required('Login ou nome de usuário é o obrigatório'),
                                    password: Yup.string().max(50).required('Senha inicial é obrigatória'),
                                    email1: Yup.string().email('Formato de email está incorreto').max(255).required('Email é obrigatorio'),
                                    email2: Yup.string().email('Formato de email está incorreto').max(255).required('Confirmação do email é obrigatoria')
                                }
                            )
                        }
                        onSubmit={(values, formik) => {
                            createValues(values);
                            formik.setSubmitting(false);
                        }}

                    >

                        {({
                            errors,
                            handleBlur,
                            handleChange,
                            setFieldValue,
                            handleSubmit,
                            isSubmitting,
                            touched,
                            values
                        }) => (
                            <form onSubmit={handleSubmit}>

                                <Grid
                                    container
                                    spacing={2}
                                >

                                    <Grid
                                        item
                                        md={6}
                                        xs={6}>

                                        <TextField
                                            required
                                            error={Boolean(touched.name && errors.name)}
                                            fullWidth
                                            label="Cliente"
                                            margin="normal"
                                            name="name"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.name}
                                            variant="outlined"
                                            inputProps={{
                                                name: 'name',
                                                id: 'name',
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={6}
                                        xs={12}>
                                        <TextField
                                            required
                                            error={Boolean(touched.detail && errors.detail)}
                                            fullWidth
                                            label="Nome"
                                            margin="normal"
                                            name="detail"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.detail}
                                            variant="outlined"
                                            inputProps={{
                                                name: 'detail',
                                                id: 'detail',
                                            }}
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>

                                    <Grid
                                        item
                                        md={12}
                                        xs={12}
                                    >
                                        <TextField
                                            required
                                            error={Boolean(touched.description && errors.description)}
                                            fullWidth
                                            label="Descrição"
                                            rows={2}
                                            multiline
                                            margin="none"
                                            name="description"
                                            onBlur={handleBlur}
                                            onChange={handleChange}
                                            value={values.description}
                                            variant="outlined"
                                            InputLabelProps={{ shrink: true }}
                                        />

                                    </Grid>


                                    {(values.creating) ? (
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <TextField
                                                required
                                                error={Boolean(touched.firstname && errors.firstname)}
                                                fullWidth
                                                label="Nome"
                                                margin="none"
                                                name="firstname"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.firstname}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                    ) : (
                                        <div></div>
                                    )}

                                    {(values.creating) ? (
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.lastname && errors.lastname)}
                                                fullWidth
                                                required
                                                label="Sobrenome"
                                                margin="none"
                                                name="lastname"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.lastname}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                    ) : (
                                        <div></div>
                                    )}

                                    {(values.creating) ? (
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>

                                            <TextField
                                                required
                                                error={Boolean(touched.username && errors.username)}
                                                fullWidth
                                                label="Login"
                                                margin="none"
                                                name="username"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                value={values.username}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />

                                        </Grid>

                                    ) : (
                                        <div></div>
                                    )}

                                    {(values.creating) ? (
                                        <Grid
                                            item
                                            md={6}
                                            xs={12}>
                                            <TextField
                                                required
                                                error={Boolean(touched.password && errors.password)}
                                                fullWidth
                                                label="Senha"
                                                margin="none"
                                                name="password"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                type="password"
                                                value={values.password}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                    ) : (
                                        <div></div>
                                    )}

                                    {(values.creating) ? (

                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.email1 && errors.email1)}
                                                fullWidth
                                                label="Email para enviar acesso"
                                                margin="none"
                                                name="email1"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                type="email"
                                                value={values.email1}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>

                                    ) : (
                                        <div></div>
                                    )}

                                    {(values.creating) ? (
                                        <Grid
                                            item
                                            md={12}
                                            xs={12}>
                                            <TextField
                                                error={Boolean(touched.email2 && errors.email2)}
                                                fullWidth
                                                label="Confirmação de Email"
                                                margin="none"
                                                name="email2"
                                                onBlur={handleBlur}
                                                onChange={handleChange}
                                                type="email"
                                                value={values.email2}
                                                variant="outlined"
                                                InputLabelProps={{ shrink: true }}
                                            />
                                        </Grid>
                                    ) : (
                                        <div></div>
                                    )}

                                </Grid>

                                <Box my={1}></Box>
                                <Divider />

                                <Box my={1}>
                                    <Grid container
                                        direction="row"
                                        justify="flex-end"
                                        alignItems="baseline"
                                        spacing={1}  >
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained">
                                                Salvar
                                            </Button>
                                        </Grid>
                                        <Grid item >
                                            <Button
                                                color="secondary"
                                                disabled={isSubmitting}
                                                size="small"
                                                variant="contained"
                                                onClick={() => { closeCreation() }}>
                                                Fechar
                                            </Button>
                                        </Grid>
                                    </Grid>
                                </Box>

                            </form>
                        )}
                    </Formik>

                </DialogContent>

            </Dialog>

        </Fragment>
    );
};

export default Create;
